// extracted by mini-css-extract-plugin
export var breadcrumbs = "accountAccessRequest-module--breadcrumbs--3b26b";
export var form = "accountAccessRequest-module--form--c36c7";
export var formContainer = "accountAccessRequest-module--formContainer--dd6bf";
export var header = "accountAccessRequest-module--header--23bbf";
export var pageWrapper = "accountAccessRequest-module--pageWrapper--3fdd4";
export var supportRequestHeader = "accountAccessRequest-module--supportRequestHeader--213e0";
export var textPaddingTop = "accountAccessRequest-module--textPaddingTop--4a81a";